module.exports = __webpack_public_path__ + "static/media/taxijoin_04.a1b40e4b.png";